export * from './lmi-proof-doc-type-select.component';
